//frontend/src/components/ui/card.jsx
import React from 'react';

export function Card({ className, children, ...props }) {
  return (
    <div 
      className={`bg-white rounded-lg shadow-lg ${className || ''}`} 
      {...props}
    >
      {children}
    </div>
  );
}

Card.displayName = 'Card';